import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import { getAppShortlink } from 'ecosystem-marketplace-core/assets/utils/urls';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import ModuleDetailsResponse from 'marketplace-ui-assets-core/details/records/ModuleDetailsResponse';
import { GET_MODULE_DETAILS_PREVIEW } from '../queries/moduleDetailsPreviewQuery';
import NotFoundError from '../../components/error/NotFoundError'; // @ts-expect-error untyped dependency

import GenericError from '../../components/error/GenericError';
import ModuleDetailsPage from '../components/ModuleDetailsPage'; // @ts-expect-error untyped dependency

import UsageTrackerContext from '../../context/UsageTrackerContext';
export default function ModuleDetailsPreviewContainer() {
  const {
    slug
  } = useParams();
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_MODULE_DETAILS_PREVIEW, {
    variables: {
      slug
    }
  });
  const moduleDetails = useMemo(() => {
    const detailsPreviewData = data || previousData;

    if (!detailsPreviewData) {
      return new ModuleDetailsResponse();
    } else {
      return new ModuleDetailsResponse(detailsPreviewData.detailsPreview);
    }
  }, [data, previousData]);
  const requestState = getDataFetchingClientRequestState(error, loading);

  const getErrorState = errorState => {
    if (errorState && errorState.networkError && errorState.networkError.statusCode) {
      if (errorState.networkError.statusCode === 403) {
        return 403;
      } else if (errorState.networkError.statusCode === 404) {
        return 404;
      }
    }

    return null;
  };

  if (error) {
    switch (getErrorState(error)) {
      case 403:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "MODULE_DETAILS_FORBIDDEN_ERROR_LOAD",
            children: /*#__PURE__*/_jsx(UIErrorMessage, {
              illustration: "keys",
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.details.previewForbiddenError.title"
              }),
              children: /*#__PURE__*/_jsx(UIButton, {
                className: "m-top-4",
                href: getAppShortlink({
                  pathname: `/modules/_preview/${slug}`
                }, false),
                use: "tertiary",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.details.previewForbiddenError.buttonText"
                })
              })
            })
          });
        }

      case 404:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "MODULE_DETAILS_404_LOAD",
            children: /*#__PURE__*/_jsx(NotFoundError, {})
          });
        }

      default:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "MODULE_DETAILS_ERROR_LOAD",
            children: /*#__PURE__*/_jsx(GenericError, {})
          });
        }
    }
  }

  if (requestState !== RequestState.SUCCEEDED) {
    return null;
  }

  return /*#__PURE__*/_jsxs(UsageTrackerContext.Provider, {
    value: {
      screen: 'details preview'
    },
    children: [/*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.previewAlert.title"
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.previewAlert.message"
      })
    }), /*#__PURE__*/_jsx(ModuleDetailsPage, {
      moduleDetails: moduleDetails,
      use: "preview"
    })]
  });
}